module.exports = __webpack_public_path__ + "img/action-report.7b5df953.svg";